import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import WaterMark from "../../Components/WaterMark/WaterMark.jsx";

const DealerTableComponent = ({ tableData, columns, heading }) => {
  const table = useReactTable({
    data: tableData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="relative shadow-lg rounded-lg pt-2 bg-white mt-2 md:mt-0 ">
      <WaterMark />
      <div className="pb-1 text-lg font-bold text-gray-800 pl-2">{heading}</div>
      <div className="drilltable">
        <table className="w-full border-collapse border border-[#B9B9B9]">
          <thead className="bg-[#28526E] text-white text-xs">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="border border-[#B9B9B9] text-center px-2 py-1"
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext(),
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody>
            {table.getRowModel().rows.map((row) => {
              const isTotalRow = row.original.category === "Total";
              return (
                <tr
                  key={row.id}
                  className={
                    isTotalRow ? "bg-[#28536F] text-white font-bold" : ""
                  }
                >
                  {row.getVisibleCells().map((cell, index) => (
                    <td
                      key={cell.id}
                      className={`border border-[#EEF0F5] text-center text-xs px-2 py-[6px] ${
                        isTotalRow
                          ? "bg-[#28536F] text-white font-bold"
                          : index === 0
                            ? "bg-[#D4E1EC]"
                            : ""
                      }`}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
        {heading === "Stock Analysis" && (
          <p className="text-gray-500 p-1 text-sm ">
            Stock in Days = (Closing Stock / Retail of Previous month) * 30
          </p>
        )}
      </div>
    </div>
  );
};

export default DealerTableComponent;
